<powerbi-report
  [embedConfig]="embedConfig"
  [eventHandlers]="eventHandlersMap"
>
</powerbi-report>
